import { IPurchase } from '@snackpass/snackpass-types';
import React, { Fragment } from 'react';

import Tile from '../Tile';
import {
    getActivePurchasesSorted,
    getActiveStore,
    getNumTiles,
} from 'src/modules/Redux';
import { useAppDispatch } from 'src/modules/Redux/store';
import { NoOrders } from '../NoOrders';
import { useSelector } from 'react-redux';
import { setShowSettingsModal } from 'src/modules/Redux/slices/settings';
import { normalizedOrderStatus } from 'src/modules/Utils/helpers';
import { IOrderStatus } from 'src/modules/Types';

const Tiles: React.FC = () => {
    const numTiles = useSelector(getNumTiles);
    const purchases = useSelector(getActivePurchasesSorted);
    const readyOrders = purchases.filter(
        p => normalizedOrderStatus(p) === IOrderStatus.Ready
    );

    const inProgressOrders = purchases.filter(
        p => normalizedOrderStatus(p) === IOrderStatus.InProgress
    );

    const dispatch = useAppDispatch();
    const activeStore = useSelector(getActiveStore);
    const _handleClick = () => {
        dispatch(setShowSettingsModal(true));
    };

    if (!numTiles) {
        return <NoOrders />;
    }

    return (
        <div>
            <div
                className="bg-primary w-full text-white flex justify-between items-center"
                style={{
                    backgroundColor: activeStore?.brandColor || '#00BFFF',
                    padding: '1.25em',
                    paddingTop: '.75em',
                    paddingBottom: '.75em',
                }}
                onClick={_handleClick}
            >
                <p className="font-bold leading-normal text-white text-[1.5em]">
                    READY
                </p>
                <div
                    className="rounded-full h-[3em] w-[3em] bg-white bg-cover bg-center bg-no-repeat border border-white"
                    style={{
                        backgroundImage: `url(${activeStore?.logoUrl || ''})`,
                    }}
                ></div>
            </div>
            <div
                className="grid"
                style={{
                    gridTemplateColumns:
                        'repeat(auto-fit, minmax(10.5em, 1fr))',
                }}
            >
                {readyOrders
                    ?.reverse()
                    .map((purchase: IPurchase, index: number) => {
                        return (
                            <Fragment key={purchase._id}>
                                <Tile
                                    key={purchase?._id}
                                    index={index}
                                    purchase={purchase}
                                />
                            </Fragment>
                        );
                    })}
            </div>

            <div
                className="w-full text-primary"
                style={{
                    backgroundColor: '#F4F5F6',
                    padding: '1.25em',
                    paddingTop: '.75em',
                    paddingBottom: '.75em',
                }}
            >
                <p className="font-bold leading-normal text-[#0F0F0F] text-[1.5em]">
                    IN PROGRESS
                </p>
            </div>

            <div
                className="grid"
                style={{
                    gridTemplateColumns:
                        'repeat(auto-fit, minmax(10.5em, 1fr))',
                }}
            >
                {inProgressOrders
                    ?.reverse()
                    .map((purchase: IPurchase, index: number) => {
                        return (
                            <Fragment key={purchase._id}>
                                <Tile
                                    key={purchase?._id}
                                    index={index}
                                    purchase={purchase}
                                />
                            </Fragment>
                        );
                    })}
            </div>
        </div>
    );
};

export default React.memo(Tiles);
